import { useMemo } from 'react';
import { generateInnerDefaultFormatter } from '@fabric-ui/components/Table';
import { flex } from '@fabric-ui/theme';
import { Box, Divider } from '@mui/material';
import { generateUUID } from '@utils/utils';
import { useAvContext } from '../../context/AvContextProvider';
import { useGetFieldType } from '../../views/CustomDashboards/hooks/useGetFieldType';
import { DimensionFormattingCondition } from '../../views/FormattingRules/types';
import ColorItem from './ColorItem';

export const getConditionTitle = (condition: DimensionFormattingCondition, dimType: string | undefined) =>
  generateInnerDefaultFormatter({ value: condition.filter?.expression?.stringCondition?.equals, type: dimType }) ?? 'Null';

function StringConditionColorDescription({ rule, colorSize }) {
  const { formattingConditions, fallbackLogic } = rule;

  const {
    accountEntities: { fieldMap },
  } = useAvContext();

  const conditionWithoutLast = fallbackLogic ? formattingConditions.slice(0, -1) : formattingConditions;
  const fallbackCondition = fallbackLogic ? formattingConditions.at(-1) : undefined;

  const getFieldType = useGetFieldType(fieldMap[rule.fieldName].mainProjId.name);
  const dimType = useMemo(() => getFieldType({ entityFieldKey: rule.fieldName }), [rule]);

  return (
    <Box sx={{ ...flex.row, gap: 1 }}>
      {conditionWithoutLast.map((value, index) => (
        <Box key={generateUUID()} sx={{ ...flex.center, gap: 1 }}>
          <Box sx={{ ...flex.row, whiteSpace: 'nowrap' }}>{getConditionTitle(value, dimType)}</Box>
          <ColorItem item={value.color} size={colorSize} />
          {index !== rule.formattingConditions.length - 1 && <Divider orientation="vertical" />}
        </Box>
      ))}
      {fallbackLogic && fallbackCondition && (
        <Box sx={{ ...flex.center }}>
          <ColorItem item={fallbackCondition.color} size={colorSize} />
        </Box>
      )}
    </Box>
  );
}

export default StringConditionColorDescription;
